import React from 'react';
import { default as withRouter } from "../../components/WithRouter/withRouter";

import Registration, { RegistrationTypes } from '../Registration/Registration';
import Success from '../Success/Success';
import CalculatorLayout from '../../components/CalculatorLayout/CalculatorLayout';
import { triggerConversionEvent } from '../../utils/paymentHelpers';

class ImABusinessOwner extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: "register"
    };
  }

  onSuccess = () => {
    this.setState({ mode: "success" }, () => {
      triggerConversionEvent('business');
    });
  }

  render() {
    return (
      <CalculatorLayout title="'m a business owner" highlightChar="i" hideTitle={this.state.mode === 'success'}>
        {this.state.mode !== 'success' &&
          <>
            <Registration type={RegistrationTypes.business} image={'/assets/reciprocity-business-logo.png'} submitText="Get in touch"
              buttonColor="#6D5B9E"
              subText={
                <>
                  <p>
                    Reciprocity payments offer a simple, accessible way for homes, businesses, and
                    events to act on the Indigenous principles that shaped and were shaped by the lands and
                    waters we love and rely on. They are voluntary, ongoing contributions that move beyond
                    symbolic acknowledgment toward meaningful action and meaningful relationships.
                  </p>
                  <p>
                    We recommend following the Pledge 1% model, which commits 1% of profits, shares, time and/or product. Let’s figure out what this might look like for you!
                  </p>
                </>
              }
              onSuccess={this.onSuccess}
            />
          </>
        }
        {this.state.mode === 'success' &&
          <Success type='business'></Success>
        }
      </CalculatorLayout>
    )
  }
}

export default withRouter(ImABusinessOwner);
